import React from 'react';
import radium from 'radium';
import { connect } from 'react-redux';

import './TitleHeader.scss';
import {ThemeContext} from "../theme/Theme.jsx";


class TitleHeader extends React.Component {
	static contextType = ThemeContext;
	constructor(props) {
		super(props);
	}
	render() {
		const style = {
			titleHeader: {
				fontFamily: this.context.themeManager
					.value('title-header', 'fontFamily', 'text-font-family-standart'),

				fontSize: this.context.themeManager
					.value('title-header', 'fontSize', 'layout-font-size'),

				color: this.context.themeManager
					.value('title-header', 'color', 'title-header-color'),

				background: this.context.themeManager
					.value('title-header', 'background', 'title-header-background'),

				padding: this.context.themeManager
					.valueOrDefault('title-header', 'padding', null, '1em'),

				fontWeight: this.context.themeManager
					.valueOrDefault('title-header', 'fontWeight', null, '600'),
				textAlign: 'center',
			},
		};
		return (
			<h1
				className="title-header"
				style={style.titleHeader}
			>
				{this.props.event.title} {this.props.event.subtitle ? '-' : ''} {this.props.event.subtitle}
			</h1>
		);
	}
}


// ------------------------------
// Store Connection
// ------------------------------

const mapStateToProps = (state) => {
	const event = state.event.elements[state.event.selected] || {};
	return {
		event,
	};
};

const mapDispatchToProps = () => ({
});


export default connect(
	mapStateToProps,
	mapDispatchToProps
)(radium(TitleHeader));
